import React from 'react'
import { Button as MuiButton, useTheme } from '@mui/material'
import { ArrowSmallIcon } from 'packages/eid-icons'

const Button = ({ onClick, title }) => {
    const theme = useTheme()
    return (
        <MuiButton
            size="small"
            sx={{
                width: '102px',
                height: '31px',
                backgroundColor: theme?.palette?.grey?.[900],
                boxShadow: '0 0 0 0',
                color: theme?.palette?.common?.white,
                textTransform: 'capitalize !important',
                borderRadius: '16px',
                position: 'absolute',
                top: '-15px',
                zIndex: 1,
                fontSize: '14px',
                right: '22px',

                '&:hover': {
                    backgroundColor: '#74787e',
                    color: theme?.palette?.common?.white,
                    '& span': {
                        color: theme?.palette?.common?.white,
                    },
                },
            }}
            variant="outlined"
            onClick={onClick}
            tabIndex={0}
            aria-label={title}
        >
            {title}
            <ArrowSmallIcon
                style={{ marginLeft: '5px' }}
                fill={'white'}
                direction={'right'}
            />
        </MuiButton>
    )
}
export default Button
